import { cva } from 'class-variance-authority';
import { Sizes } from '../enums/sizes';
import { TextSizes } from '../enums/typography-text-sizes';
import { textVariants } from './typography-text-variants';

const textSm = textVariants({ size: TextSizes.SM });
const textMd = textVariants({ size: TextSizes.MD });

export const inputVariants = cva(
  [
    'flex w-full min-w-0 items-center rounded-lg border border-primary bg-primary shadow-xs',
    'outline-2 outline-offset-[-2px] outline-transparent',
    'hover:not-has-[:disabled]:border-utility-gray-400',
    'focus-within:not-has-[:disabled]:border-brand focus-within:not-has-[:disabled]:outline-brand focus-within:not-has-[:disabled]:hover:border-brand',
    'has-[[aria-invalid=true]]:border-error has-[[aria-invalid=true]]:hover:border-error has-[[aria-invalid=true]]:focus-within:outline-error has-[[aria-invalid=true]]:focus-within:border-error',
    'has-[:disabled]:cursor-not-allowed has-[:disabled]:[&>:not([data-slot=input-trailing])]:opacity-50',
    '[&_[data-slot=button]]:rounded-sm',
  ].join(' '),
  {
    variants: {
      size: {
        [Sizes.SM]: `h-9 gap-2 px-3 ${textSm}`,
        [Sizes.MD]: `h-10 gap-2 px-3 ${textMd}`,
        [Sizes.LG]: `h-11 gap-2 px-3.5 ${textMd}`,
      },
    },
    defaultVariants: {
      size: Sizes.SM,
    },
  }
);
